import React, { useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate } from 'react-router-dom'

import img2 from '../../assest/loading1.gif'

import { getApi } from '../../Repository/Api'
import endPoints from '../../Repository/apiConfig'


const Adminprofile = () => {
    const navigate = useNavigate()
    const [profile, setProfile] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        await getApi(endPoints.getprofile, {
            setResponse: setProfile,
            setLoading,
            errorMsg: 'Failed to fetch profile!'
        });
    };


    useEffect(() => {
        fetchData();
    }, []);


    return (
        <>
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Admin Profile</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <button onClick={() => navigate(-1)}>Back</button>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    {loading ? (
                        <div className={addjob.loadingnormal}>
                            <img src={img2} alt="Loading" width={100} height={100} />
                        </div>
                    ) : (
                        <div className={addjob.addusercontainer}>
                            <div className={addjob.adduserleftcontainer}>
                                <h6>Admin Details</h6>
                                <div className={addjob.adduserleftdetails}>
                                    <div className={addjob.adduserleftprofileimage}>
                                        <img src={profile?.data?.image} alt="" />
                                    </div>
                                    <div className={addjob.adduserleftuserdetails}>
                                        <div className={addjob.adduserleftuser}>
                                            <p>Name</p>
                                            <span>:</span>
                                            <p>{profile?.data?.firstName} {profile?.data?.lastName}</p>
                                        </div>
                                        <div className={addjob.adduserleftuser}>
                                            <p>Email</p>
                                            <span>:</span>
                                            <p>{profile?.data?.email}</p>
                                        </div>
                                        <div className={addjob.adduserleftuser}>
                                            <p>Number</p>
                                            <span>:</span>
                                            <p>+91{profile?.data?.phone}</p>
                                        </div>
                                        {/* <div className={addjob.adduserleftuser}>
                                            <p>Role</p>
                                            <span>:</span>
                                            <p>Bartender</p>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            {/* <div className={addjob.adduserrightcontainer}>
                                <h6>Documents</h6>
                                <div className={addjob.adduserrighttdocumentdetails}>
                                    <div className={addjob.adduserrightdocumentimage}>
                                        <div className={addjob.adduserrightdocument}>

                                        </div>
                                        <div className={addjob.adduserrightdocument}>

                                        </div>
                                        <div className={addjob.adduserrightdocument}>

                                        </div>
                                        <div className={addjob.adduserrightdocument}>

                                        </div>
                                    </div>
                                    <div className={addjob.adduserleftuserdetails}>
                                        <div className={addjob.adduserleftuser}>
                                            <p>Description</p>
                                            <span>:</span>
                                            <h5>Lorem ipsum dolor sit amet consectetur. Egestas arcu orci neque vitae. Turpis cursus nec.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>

                    )}
                </div>

            </div>
        </>
    )
}

export default HOC(Adminprofile)